import React, { useState } from 'react';

const SkillsTabs = () => {
  const [activeTab, setActiveTab] = useState('Languages');

  const renderContent = () => {
    const skillItem = (src, label, details) => (
      <div className="skill-item">
        <div className="skill-front">
          <img 
            src={src} 
            alt={label} 
            className={`skill-icon ${label === 'Node.js' ? 'nodejs-icon' : ''}`} 
          />
          <span className="skillName">{label}</span>
        </div>
        <ul className="skill-details">
          {details.map((item, index) => (
            <li key={index}>{item}</li>
          ))}
        </ul>
      </div>
    );
    switch (activeTab) {
      case 'Languages':
        return (
          <div className="skills-grid">
            {skillItem('/assets/pythonLogo.png', 'Python', ['Scripts & Automation', 'APIs', 'Data Analysis'])}
            {skillItem('/assets/javaScriptLogo.png', 'JavaScript', ['Data Analysis', 'DOM Manipulation', 'Asynchronous Code'])}
            {skillItem('/assets/r-lang.png', 'R', ['Statistical Analysis', 'Data Wrangling', 'Exploratory Data Analysis'])}
            {skillItem('/assets/sqlLogo.png', 'SQL', ['Joins & Queries', 'Data Retrieval', 'Data Manipulation'])}
          </div>
        );
      case 'Frameworks':
        return (
          <div className="skills-grid">
            {skillItem('/assets/excelLogo.png', 'Excel', ['Pivot Tables', 'Data Cleaning & Transformation', 'Advanced Formulas', 'Dashboard Reporting'])}
            {skillItem('/assets/pandasLogo.png', 'pandas', ['Data Wrangling', 'Time Series Analysis', 'DataFrame Operations', 'CSV & SQL Integration'])}
            {skillItem('/assets/sqlalchemyLogo.png', 'SQLAlchemy', ['ORM Queries', 'Database Connections', 'Schema Management', 'Python-SQL Integration'])}
            {skillItem('/assets/postgresLogo.png', 'PostgreSQL', ['Complex Joins & Queries', 'Schema Design', 'Performance Tuning', 'Data Normalization'])}
          </div>
        );
      case 'Soft Skills':
        return (
          <div className="skills-grid">
            {skillItem('/assets/analyticalLogo.png', 'Analytical Thinking', [
              'Identifying patterns and anomalies in complex datasets',
              'Translating raw data into actionable insights',
              'Designing rule-based diagnostic logic'
            ])}
            {skillItem('/assets/problemsolve.png', 'Problem Solving', [
              'Debugging data pipeline and system issues',
              'Breaking down ambiguous problems into structured solutions',
              'Applying logic to optimize workflows and reduce downtime'
            ])}
            {skillItem('/assets/datastoryLogo.png', 'Data Storytelling', [
              'Presenting technical findings to non-technical stakeholders',
              'Building dashboards and reports that drive decisions',
              'Bridging the gap between data output and business needs'
            ])}
            {skillItem('/assets/detailLogo.png', 'Attention to Detail', [
              'Validating data integrity across ingestion and reporting',
              'Catching edge cases in diagnostic and anomaly detection scripts',
              'Ensuring accuracy in client-facing outputs'
            ])}
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <div className="skills-tabs-container">
      <div className="tabs-header">
        <button
          onClick={() => setActiveTab('Languages')}
          className={`tab-button ${activeTab === 'Languages' ? 'active-tab' : ''}`}
        >
          Languages
        </button>
        <button
          onClick={() => setActiveTab('Frameworks')}
          className={`tab-button ${activeTab === 'Frameworks' ? 'active-tab' : ''}`}
        >
          Frameworks
        </button>
        <button
          onClick={() => setActiveTab('Soft Skills')}
          className={`tab-button ${activeTab === 'Soft Skills' ? 'active-tab' : ''}`}
        >
          Soft Skills
        </button>
      </div>

      <div className="tab-content" key={activeTab}>
        {renderContent()}
      </div>
    </div>
  );
};

export default SkillsTabs;
